<template>
    <form id="battle-form" @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="grid">
            <div class="col-12">
                <as-title class="title"
                    :title="$t('ficheBu.battle_form.' + (battle.id ? 'edit_battle_title' : 'new_battle_title'))"
                    :size="3" />
            </div>
            <div class="field col-12">
                <div class="p-float-label">
                    <InputText type="text" v-model="v$.adminTitle.$model" class="w-100"
                        :class="{ 'p-invalid': v$.adminTitle.$invalid && submitted }" />
                    <label>{{ $t("ficheBu.battle_form.battle_admin_title") }}</label>
                </div>
                <as-input-error :errors="v$.adminTitle.$silentErrors" v-show="submitted" />
            </div>

            <div class="col-12">
                <div class="flex w-100">
                    <as-title :title="$t('ficheBu.battle_form.battle_history_title')" :size="3"></as-title>
                    <div class="ml-auto">
                        <Button :label="$t('ficheBu.battle_form.battle_new_history_button_label')"
                            class="button-default" @click="addHistory" />
                    </div>
                </div>
                <div class="grid">
                    <div v-for="(battleHistory, index) in state.battleHistory" :key="battleHistory.date + index"
                        class="col-6">
                        <Card class="bloc-card">
                            <template #header>
                                <div class="flex w-100 p-2 bg-primary-sliced">
                                    <span class="bloc-index">{{ battleHistory.date ? formatDate(battleHistory.date) :
                                        '???' }}</span>
                                    <i class="pi pi-times-circle ml-auto bloc-remove-icon" style="font-size: 28px;"
                                        @click="showConfirmModalRemoveHistory(index)"></i>
                                </div>
                            </template>
                            <template #content class="p-0">
                                <div class="grid field mt-3">
                                    <div class="col-6">
                                        <div class="p-float-label">
                                            <Calendar v-model="state.battleHistory[index].date" view="month"
                                                dateFormat="mm/yy" class="w-100" />
                                            <label>{{ $t("ficheBu.battle_form.battle_history_date_field") }}</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <TranslateButton :stringsToTranslate="getStringsToTranslate(index)"
                                            buttonClass="w-100"
                                            @onTranslationSuccess="(translatedData, targetLangCode) => handleTranslationSuccess(index, translatedData, targetLangCode)" />
                                    </div>
                                </div>

                                <TabView>
                                    <TabPanel>
                                        <template #header>
                                            <div class="flex align-items-center gap-2">
                                                <Avatar :image="getFlag('fr')" shape="square" />
                                                <span class="font-bold white-space-nowrap">FR</span>
                                            </div>
                                        </template>
                                        <div class="mt-3">
                                            <div class="p-float-label">
                                                <InputText type="text" v-model="state.battleHistory[index].titleFr"
                                                    class="w-100"
                                                    :class="{ 'p-invalid': v$.battleHistory[index]?.titleFr.$invalid && state.submitted }" />
                                                <label>
                                                    {{ $t("ficheBu.priority_form.priority_history_title_field") }}
                                                </label>
                                            </div>
                                            <div class="p-float-label flex mt-3">
                                                <as-title :title="$t('ficheBu.battle_form.battle_history_items_title')"
                                                    :size="5"></as-title>
                                                <div class="ml-auto">
                                                    <Button
                                                        :label="$t('ficheBu.battle_form.battle_history_items_newx_item_button_label')"
                                                        class="button-default" @click="addItem(index)" />
                                                </div>
                                            </div>
                                            <div class="grid field">
                                                <div class="col-12">
                                                    <div v-for="(e, itemIndex) in battleHistory.battleHistoryItem"
                                                        :key="index + '-' + itemIndex" class="field">
                                                        <div class="p-float-label flex">
                                                            <InputText type="text" v-model="e.labelFr" class="flex-1"
                                                                :class="{ 'p-invalid': v$.battleHistory[index]?.battleHistoryItem[itemIndex]?.labelFr.$invalid && state.submitted }" />
                                                            <Button icon="pi pi-trash" class="p-button-danger ml-2"
                                                                @click="removeItem(index, itemIndex)" />
                                                        </div>
                                                        <as-input-error v-if="v$.battleHistory[index]"
                                                            :errors="v$.battleHistory[index]?.battleHistoryItem[itemIndex]?.labelFr.$silentErrors"
                                                            v-show="state.submitted" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <template #header>
                                            <div class="flex align-items-center gap-2">
                                                <div class="flex align-items-center gap-2">
                                                    <Avatar :image="getFlag('en')" shape="square" />
                                                    <span class="font-bold white-space-nowrap">EN</span>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="mt-3">
                                            <div class="p-float-label">
                                                <InputText type="text" v-model="state.battleHistory[index].titleEn"
                                                    class="w-100"
                                                    :class="{ 'p-invalid': v$.battleHistory[index]?.titleEn.$invalid && state.submitted }" />
                                                <label>
                                                    {{ $t("ficheBu.priority_form.priority_history_title_field") }}
                                                </label>
                                            </div>
                                            <div class="p-float-label flex mt-3">
                                                <as-title :title="$t('ficheBu.battle_form.battle_history_items_title')"
                                                    :size="5"></as-title>
                                                <div class="ml-auto">
                                                    <Button
                                                        :label="$t('ficheBu.battle_form.battle_history_items_newx_item_button_label')"
                                                        class="button-default" @click="addItem(index)" />
                                                </div>
                                            </div>
                                            <div class="grid field">
                                                <div class="col-12">
                                                    <div v-for="(e, itemIndex) in battleHistory.battleHistoryItem"
                                                        :key="index + '-' + itemIndex" class="field">
                                                        <div class="p-float-label flex">
                                                            <InputText type="text" v-model="e.labelEn" class="flex-1"
                                                                :class="{ 'p-invalid': v$.battleHistory[index]?.battleHistoryItem[itemIndex]?.labelEn.$invalid && state.submitted }" />
                                                            <Button icon="pi pi-trash" class="p-button-danger ml-2"
                                                                @click="removeItem(index, itemIndex)" />
                                                        </div>
                                                        <as-input-error v-if="v$.battleHistory[index]"
                                                            :errors="v$.battleHistory[index]?.battleHistoryItem[itemIndex]?.labelEn.$silentErrors"
                                                            v-show="state.submitted" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </TabView>
                                <as-input-error v-if="v$.battleHistory[index]"
                                    :errors="v$.battleHistory[index].title.$silentErrors" v-show="state.submitted" />
                            </template>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid fixed-bottom">
            <div class="col flex justify-content-end">
                <Button :label="$t('form.cancel_button')" class="button-default"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-times'" @click="onClose"
                    :disabled="isSending" />
                <Button type="submit" :label="$t('form.submit_button')" class="button-primary ml-2"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-check'" :disabled="isSending" />
            </div>
        </div>
    </form>
    <as-confirm-modal :isVisible="showRemoveHistoryConfirmModal"
        :modalMessage="$t('rituals.ritual_form.ritual_remove_subject_confirm_message')" @onConfirm="removeHistory"
        @onCancel="cancelConfirmModalRemoveHistory" />
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { helpers, required } from "@vuelidate/validators"
import { reactive, computed, watch } from "vue"

import AsTitle from "../Elements/AsTitle.vue"
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";
import AsInputError from "../Forms/AsInputError.vue"

import Avatar from "primevue/avatar";
import Button from "primevue/button"
import Card from "primevue/card";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext"
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import TranslateButton from "../Elements/TranslateButton.vue";
import moment from "moment"

export default {
    name: "BattleForm",
    components: {
        AsTitle,
        AsConfirmModal,
        AsInputError,
        Avatar,
        Button,
        Card,
        Calendar,
        InputText,
        TabView,
        TabPanel,
        TranslateButton
    },
    props: {
        battle: Object,
        isSending: Boolean,
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        },
    },
    setup(props) {
        const state = reactive({
            adminTitle: props.battle?.adminTitle || "",
            battleHistory: props.battle?.battleHistory
                ? props.battle.battleHistory.map(e => ({
                    ...e,
                    date: new Date(e.date),
                    battleHistoryItem: e.battleHistoryItem
                        ? e.battleHistoryItem.map(i => ({ ...i }))
                        : [],
                }))
                : [{ date: new Date(), titleFr: "", titleEn: "", battleHistoryItem: [{ labelFr: "", labelEn: "" }] }],
            submitted: false,
        });
        const rules = computed(() => ({
            adminTitle: { required },
            battleHistory: {
                $each: helpers.forEach({
                    date: {},
                    titleFr: {},
                    titleEn: {},
                    battleHistoryItem: {
                        $each: helpers.forEach({
                            labelFr: {},
                            labelEn: {},
                        }),
                    },
                }),
            },
        }))
        const v$ = useVuelidate(rules, state)
        return { v$, state }
    },
    data() {
        return {
            submitted: false,
            showRemoveHistoryConfirmModal: false,
            historyIndexToRemove: null,
        }
    },
    validations() {
        return {
            title: { required },
        }
    },
    emits: ["onClose", "onSubmit"],
    methods: {
        handleSubmit(isFormValid) {
            this.submitted = true
            if (!isFormValid) {
                return;
            }
            const battle = {
                id: this.battle.id,
                adminTitle: this.state.adminTitle,
                battleHistory: [...this.state.battleHistory].filter(e => e.titleFr.trim() !== "" && e.date !== null)
            }
            this.submitted = false
            this.$emit("onSubmit", battle)
        },
        onClose() {
            this.state.adminTitle = ""
            this.state.battleHistory = [{ titleFr: "", titleEn: "", battleHistoryItem: [{ labelFr: "", labelEn: "" }] }]
            this.submitted = false
            this.$emit("onClose");
        },
        addHistory() {
            const lastHistory = this.state.battleHistory?.length >= 0 ?
                [...this.state.battleHistory].filter(e => !!e.date).sort((a, b) =>
                    moment(b.date).toDate().getTime() - moment(a.date).toDate().getTime()
                )[0] : null
            const newHistoryDate = lastHistory ? moment(lastHistory.date).add(1, 'month').toDate() : new Date()
            const newHistoryItems = lastHistory ? lastHistory.battleHistoryItem.map(item => ({ ...item })) : [{ labelFr: "", labelEn: "" }]
            newHistoryItems.forEach(e => {
                delete e.id
                delete e.idBattleHistory
            });

            const sortedHistories = [
                ...this.state.battleHistory,
                { id: 0, date: newHistoryDate, titleFr: lastHistory?.titleFr || "", titleEn: lastHistory?.titleEn || "", battleHistoryItem: newHistoryItems }
            ].sort((a, b) => moment(b.date).toDate().getTime() - moment(a.date).toDate().getTime())
            this.state.battleHistory = sortedHistories
        },
        addItem(battleIndex) {
            if (!this.state.battleHistory[battleIndex].battleHistoryItem) { this.state.battleHistory[battleIndex].battleHistoryItem = [] }
            this.state.battleHistory[battleIndex].battleHistoryItem.push({ id: 0, labelFr: "", labelEn: "" })
        },
        removeHistory() {
            this.showRemoveHistoryConfirmModal = false
            if (!this.historyIndexToRemove === null) { return }
            this.state.battleHistory.splice(this.historyIndexToRemove, 1)
            this.historyIndexToRemove = null
        },
        removeItem(battleIndex, itemIndex) {
            this.state.battleHistory[battleIndex].battleHistoryItem.splice(itemIndex, 1)
        },
        showConfirmModalRemoveHistory(index) {
            this.showRemoveHistoryConfirmModal = true
            this.historyIndexToRemove = index
        },
        cancelConfirmModalRemoveHistory() {
            this.showRemoveHistoryConfirmModal = false
            this.historyIndexToRemove = null
        },
        formatDate(date) {
            return moment(date).format("MM/YYYY");
        },
        getFlag(iso) {
            return new URL(`../../assets/images/flags/${iso}.svg`, import.meta.url).href;
        },
        getStringsToTranslate(index) {
            const battleToTranslate = this.state.battleHistory[index]
            const targetTranslate = this.locale === 'fr' ? 'en' : 'fr'

            const itemsToTranslate = battleToTranslate.battleHistoryItem.map(e => targetTranslate === 'fr' ? e.labelEn : e.labelFr)
            const stringsToTranslate = targetTranslate === 'fr' ?
                [battleToTranslate.titleEn, ...itemsToTranslate] :
                [battleToTranslate.titleFr, ...itemsToTranslate]
            return stringsToTranslate;
        },
        handleTranslationSuccess(index, translatedData, targetLangCode) {
            if (Array.isArray(translatedData)) {
                switch (targetLangCode) {
                    case 'en':
                        this.state.battleHistory[index].titleEn = translatedData.shift()
                        translatedData.forEach((translate, itemIndex) => {
                            this.state.battleHistory[index].battleHistoryItem[itemIndex].labelEn = translate
                        })
                        break;
                    case 'fr':
                        this.state.battleHistory[index].titleFr = translatedData.shift()
                        translatedData.forEach((translate, itemIndex) => {
                            this.state.battleHistory[index].battleHistoryItem[itemIndex].labelFr = translate
                        })
                        break;
                }
            }
        },
    },
};
</script>



<style lang="scss">
@import "../../assets/styles/colors.scss";

#battle-form {
    .bloc-card {
        .bloc-index {
            width: 100px;
        }
    }

    .p-tabview-panels {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
